import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

interface Teacher {
  firstname: string;
  lastname: string;
  gender: string; // جنسیت
  respectfulPrefix: string; // پیش‌وند محترمانه
}

interface Teachers {
  [teacher: string]: Teacher;
}

let habibi: Teacher = {
  firstname: 'میلاد',
  lastname: 'حبیبی‌نیا',
  gender: 'مرد',
  respectfulPrefix: 'آقای',
}
let pirayeh: Teacher = {
  firstname: 'سهراب',
  lastname: 'پیرایه',
  gender: 'مرد',
  respectfulPrefix: 'آقای',
}
let salimi: Teacher = {
  firstname: 'محمدباقر',
  lastname: 'سلیمی',
  gender: 'مرد',
  respectfulPrefix: 'آقای',
}
let threeTeacher: Teacher = {
  firstname: '',
  lastname: 'عنایت‌خواه، حبیبی‌نیا و سلیمی',
  gender: 'مرد',
  respectfulPrefix: 'آقایان',
}

@Component({
  selector: 'mizvid-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  choosenTeachear: Teacher;
  respectfulName: string;
  classTitle: string;
  pageTitle: string;

  constructor(private titleService: Title){
    this.choosenTeachear = threeTeacher;
    this.respectfulName = this.choosenTeachear.respectfulPrefix + " " + this.choosenTeachear.lastname
    this.classTitle = `کلاس ${this.respectfulName}`;
    this.pageTitle = this.classTitle;
    this.titleService.setTitle(this.pageTitle)
  }



  ngOnInit(): void {}

}

